<ion-label
  class="text-sm font-semibold pl-2"
  [color]="!isWeb ? 'light' : 'secondary'"
  >{{ field.label | translate }}</ion-label
>

<div
  *ngIf="field && inputControl && field.type !== 'file' && field.type !== 'date'"
  class="rounded-lg py-[15px] px-[25px] overflow-hidden flex items-center gap-3 mt-2 border"
  [ngStyle]="{ height: field.type === 'textarea' ? 'auto' : '46px', background: !isWeb ? 'transparent' : '#ebf6fb80' }"
  [class]="invalid ? 'error' : ''"
>
  <!-- INPUT TEXT -->
  <ion-input
    *ngIf="field.type === 'text'"
    #textInput
    mode="ios"
    [placeholder]="field.placeholder || (isLocationField ? ('EDIT_PROFILE.LOCATION_PLACEHOLDER' | translate) : '')"
    [type]="field.type"
    [formControl]="inputControl"
    (ionInput)="isLocationField ? onLocationInputChange($event) : null"
    (ionBlur)="isLocationField ? hideLocationSuggestions() : null"
    [class]="isWeb ? 'text-[#294D8F]' : 'text-white'"
  >
  </ion-input>
  <!-- INPUT TEXTAREA -->
  <ion-textarea
    mode="ios"
    *ngIf="field.type === 'textarea'"
    [formControl]="inputControl"
    [placeholder]="field.placeholder"
    rows="4"
    [class]="isWeb ? 'text-[#294D8F]' : 'text-white'"
  ></ion-textarea>

  <ion-icon
    [src]="field.icon"
    [color]="!isWeb ? 'light' : 'secondary'"
  ></ion-icon>
</div>

  <!-- Mensaje de error para ubicación -->
  <div *ngIf="isLocationField && inputControl?.value && hasBeenEdited && !isLocationSelected" class="error-message text-sm mt-1 pl-2" [class.text-danger]="true">
    {{ 'EDIT_PROFILE.SELECT_FROM_SUGGESTIONS' | translate }}
  </div>

    <!-- Suggestions list for location (same UX as filters) -->
  <div *ngIf="isLocationField" class="relative">
    <div *ngIf="showLocationSuggestions" class="absolute z-50 left-0 right-0 bg-white shadow-md rounded-md mt-1 max-h-60 overflow-auto border border-gray-200">
      <ion-list class="m-0 p-0">
        <ion-item button detail="false" lines="none" *ngFor="let s of locationSuggestions" (click)="selectLocationSuggestion(s)">
          <ion-label class="text-[13px] leading-tight">
            <div class="font-medium">{{ s.mainText }}</div>
            <div class="text-[11px] opacity-70" *ngIf="s.secondaryText">{{ s.secondaryText }}</div>
          </ion-label>
        </ion-item>
      </ion-list>
    </div>
  </div>

<!-- INPUT DATE -->
<div
  *ngIf="field.type === 'date'"
  class="public-input-surface public-input-surface--date rounded-lg py-[15px] px-[25px] overflow-hidden flex items-center gap-3 mt-2 border justify-between"
  [class.public-input-surface--web]="isWeb"
  [ngStyle]="{ height: isWeb ? 'auto' : '46px', background: !isWeb ? 'transparent' : '#eef8ff' }"
  [class]="invalid ? 'error' : ''"
  (click)="showCalendar()"
>
  <ion-label
    class="text-sm"
    [color]="!isWeb ? 'light' : 'secondary'"
    >{{ selectedDate || inputControl?.value }}</ion-label
  >
  <ion-icon
    [src]="field.icon"
    [color]="!isWeb ? 'light' : 'secondary'"
  ></ion-icon>
</div>
<!-- INPUT IMAGE -->
<div
  *ngIf="field.type === 'file'"
  class="mt-2 pb-2"
>
  <button
    class="h-[110px] w-[110px] flex justify-center items-center relative border border-[] border-solid rounded-[10px] !bg-cover !bg-center"
    (click)="handleImageUpload()"
    [ngStyle]="{ 'background': imageUrl ? 'url(' + imageUrl + ')' :  'transparent', 'border-color': isWeb ? '#294d8fc5' : '#ffffff9c'}"
  >
    <ion-icon
      *ngIf="!imageUrl"
      src="'../../../assets/svg/image.svg"
      class="text-[35px]"
      [class]="isWeb ? 'text-[#294d8fc5]' : 'text-[#ffffff73]'"
    ></ion-icon>
    <div class="absolute bottom-[-5px] right-[-8px] rounded-full w-6 h-6 flex justify-center items-center">
      <ion-icon
        src="../../../assets/svg/edit.svg"
        color="danger"
        class="text-[28px]"
      ></ion-icon>
    </div>
  </button>
</div>

<ion-modal
  [keepContentsMounted]="true"
  #calendar
>
  <ng-template>
    <ion-datetime
      id="datetime"
      mode="ios"
      [showDefaultButtons]="true"
      [locale]="datetimeLocale"
      [cancelText]="datetimeCancelText"
      [doneText]="datetimeDoneText"
      [value]="tempDate"
      (ionChange)="onDateChange($event)"
      [min]="field.minDate"
      [max]="field.maxDate"
      [presentation]="field.pickerFormat ? 'date' : 'date-time'"
    ></ion-datetime>
  </ng-template>
</ion-modal>
